module.exports = __webpack_public_path__ + "img/about4.4a9bb171.png";